import styled from 'styled-components';
import { HOLLA_HEADER_LOGO } from '../../config/media';

export const AvatarWrapper = styled.div`
	display: flex;
	align-items: center;
	cursor: pointer;
	span {
		margin-right: 12px;
	}
	.name {
		line-height: 1;
		margin-right: 12px;
	}
`;

export const Wrapper = styled.div`
	width: 100%;
	padding-top: 40px;
	&.pt-70 {
		padding-top: 70px;
	}
	.header {
		background-color: #000;
		color: #fff;
		/* border-bottom: 1px solid #A8A8B1; */
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: fixed;
		width: 100%;
		height: 40px;
		left: 0;
		top: 0;
		z-index: 3;
		&.ant-layout-header {
			height: 40px;
			padding: 0;
			// padding-left: 50px;
			z-index: 1000;
		}
		p {
			color: #A8A8B1 !important;
			a {
				font-weight:normal
				text-decoration:none;
				color: rgb(255 255 255 / 90%);
			}
		}
		strong {
			color: #fff;
			opacity: 0.9;
		}
		.logout {
			text-decoration:none;
			color: #A8A8B1;
			position: fixed;
			right: 10px;
		}
		.logout:hover {
			color: #ffffff;
		}
		.tabs-wrapper {
			display: flex;
			align-items: center;
		}
		.tab {
			color: #ffffff;
			text-decoration: none;
			padding: 0.5rem 1rem;
			box-sizing: border-box;
			line-height: 1.5;
			min-width: 9rem;
			opacity: 0.7;
			&.active-tab {
				background-color: #0E0E0F;
				border-top: 4px solid #3A4FFF;
				color: #FFFFFF;
				opacity: 1;
			}
		}
		.tab-divider {
			height: 14px;
			width: 0px;
			border-left: 1px solid rgb(168 168 177 / 60%);
		}
		.nav-icon {
			width: 1.4rem;
			margin-right: 0.5rem;
		}
		.right-header {
			display: flex;
			align-items: center;
			.login-btn {
				margin: 0 10px;
			}
			.get-xht {
				color: #fff;
				text-decoration: none;
				background-color: #393939;
				line-height: 1;
				padding: 4px 12px;
			}
			a {
				text-decoration: none;
				color: #fff;
			}
			.clickable {
				cursor: pointer;
			}
		}
	}
	.move_top_bar {
		top: 30px;
	}
	.exchange_status_container {
		height: 30px;
		top: 0;
		position: fixed;
		width: 100%;
    	display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1000;
		font-size: 13px;
		.main {
			font-weight: bold
		}
	}
	.status_terminated {
		background-color: red;
	}
	.status_about_to_terminate {
		background-color: orange;
	}
	.status_warning {
		background-color: #FFF700;
		color: #000000;
	}
	.status_expired {
		background-color: #FF0000;
		color: #ffffff;
	}
	.gnb {
		background-color: #fff;
		color: #000;
		padding: 20px 50px 0;
		position: relative;
		a {
			color: #b9b9b9;
			text-decoration: none;
			font-size: 24px;
			padding: 0.5rem 1rem;
			padding-bottom: 0;
			font-weight: bold;
			box-sizing: border-box;
			&.active {
				border-bottom: 3px solid #000;
				color: #000;
			}
		}
		.link-container {
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}
		.account-balance {
			position: absolute;
			right: 24px;
			bottom: 0;
			color: #b9b9b9;
			font-size: 24px;
			padding: 0 1rem;
		}
	}
`;

export const Logo = styled.div`
	width: 18px;
	height: 18px;
	position: absolute;
	left: 10px;
	top: 8px;
	background-size: cover;
	background-image: url(${HOLLA_HEADER_LOGO});
	background-position: center;
	cursor: pointer;
`;

export const headerStyle = {
	display: 'flex',
	justifyContent: 'space-between',
	paddingTop: '16px',
	paddingBottom: '16px',
	alignItems: 'center',
	height: '84px'
};

export const headerMobileStyle = {
	display: 'flex',
	backgroundColor: '#000',
	justifyContent: 'flex-end',
	padding: '0 8px',
	alignItems: 'center',
	height: '42px',
	position: 'relative'
};

export const Status = styled.div`
	display: flex;
	height: 100%;
	align-items: center;
	p {
		line-height: 1;
		padding: 0 12px;
		margin-bottom: 0;
		font-size:12px
		border-right: 1px solid rgb(168 168 177 / 60%);
		&.last {
			border-right: 0;
		}
	}
	.link {
		min-width: 120px;
	}
`;

export const LinkContainer = styled.div`
	flex: 1;
	min-width: 120px;
`;

export const MobileWrapper = styled.div`
	background-color: #f2f2f2;
	font-size: 12px;
	position: relative;
	.ant-layout-header {
        background: #0E0E0F;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: end;
        a {text-decoration:none;
        color: #fff;
        }
    }
	p {
		line-height: 1.2;
		padding: 2px 4px;
		outline: 1px solid #000;
		margin-bottom: 0;
	}
	.flex-box {
		display: flex;
		.col1 {
			flex: 2;
		}
		.col2 {
			flex: 3;
		}
	}
	.menu-icon {
		position: absolute;
		left: 8px;
		top: 10px;
		z-index: 1;
	}
	.mobile-nav {
		position: fixed;
		top: 42px;
		left: 0%;
		bottom: 0;
		right: 0;
		z-index: 30;
		background-color: #29292C;
		overflow: scroll;
		a {
			display: block;
			font-size: 22px;
			color: #fff;
			text-decoration: none;
			line-height: 1.5;
			padding:8px;
			margin: 12px 0;
			border-bottom: 1px solid #fff;
		}
	}
	.xht-header-status {
		font-size: 10px;
	}
	.header-wrapper {
		display: flex;
		flex-direction: column;
	}
	.exchange_status_container {
		height: 30px;
		top: 0;
		position: fixed;
		width: 100%;
    	display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1000;
		font-size: 13px;
		.main {
			font-weight: bold
		}
	}
	.status_terminated {
		background-color: red;
	}
	.status_about_to_terminate {
		background-color: orange;
	}
	.status_warning {
		background-color: #FFF700;
		color: #000000;
	}


	@media(max-width: 1200px) {
		.menu_mobile_icon {
			position: absolute;
			left: 8px;
			top: 38px;
			z-index: 1;
		}
		.exchange_status_container {
			position: unset;
			height: 100%;
		}
	}
`;
